import React from 'react'
import './header.css'
function Header() {
  return (
    <div className="header">
        <header class="text-gray-600 body-font">
  <div class="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
    <a class="flex title-font font-medium items-center text-gray-900 mb-4 md:mb-0">
      <span class="ml-3 text-mx" className="logo"><h2><b>Shabbeirshaik.com</b></h2></span>
    </a>
  </div>
</header>
    </div>
  )
}

export default Header